<template>
  <div>
    <h1>Таймлайн проекта</h1>
  </div>
</template>

<script>
export default {
  name: 'Timeline',

  data: () => ({
    isLoading: false
  })
}
</script>
